module.exports = __webpack_public_path__ + "img/default_bg.b2eb2cb2.png";